import { useCallback, useEffect, useState } from 'react';

/** Densidad de las listas de documentos (DESIGN.md §11.2): «Compacta» deja solo el título y la columna de datos. */
export type Densidad = 'normal' | 'compacta';

const clave = (userId?: string) => `alertai_densidad_${userId || 'anonimo'}`;
const leer = (userId?: string): Densidad => {
  try { return localStorage.getItem(clave(userId)) === 'compacta' ? 'compacta' : 'normal'; } catch { return 'normal'; }
};

/** Densidad recordada por persona (la clave lleva el id del usuario) en este navegador. */
export function useDensidad(userId?: string): [Densidad, (d: Densidad) => void] {
  const [densidad, setDensidad] = useState<Densidad>(() => leer(userId));
  // La sesión llega después del primer render: al conocer al usuario se lee su preferencia.
  useEffect(() => { setDensidad(leer(userId)); }, [userId]);
  const cambiar = useCallback((d: Densidad) => {
    setDensidad(d);
    try { localStorage.setItem(clave(userId), d); } catch { /* sin almacenamiento: vuelve a «normal» al recargar */ }
  }, [userId]);
  return [densidad, cambiar];
}
